import { createIframeElement } from './create-iframe-element.js';

/**
 * if htmlString does not include basic html structure requirements, create and wrap it around creative
 * @param {string} originalHtml
 * @returns {string}
 */
const addHtmlStructure = (originalHtml: string): string => {
    const cleanedHtml = originalHtml.trim().replace(/<script[\s\S]*?<\/script>|<style[\s\S]*?<\/style>|<!--[\s\S]*?-->/gi, '');
    const htmlStructurePresent = (/(<\/?[^\.]*?html\/?>?)|(<\/?.*?body\/?>?)/g.test(cleanedHtml));
    if (htmlStructurePresent) return originalHtml;
    return '<!DOCTYPE html><html lang="de"><head><title>Advertisement</title><style>html, body {width: 100%; height: 100%};</style></head><body style="margin:0">' + originalHtml + '</body></html>';

};

export type CreateHtmlFragmentsParameters = {
    id?: string,
    html?: string,
    styles?: Partial<CSSStyleDeclaration>,
    dataset?: Record<string, string>,
}

/**
 * creates an iframe, that will dynamically receive content as soon as it enters the site. Will resolve cross domain problems and allow more interactions between main site and iframe.
 * @param createHtmlFragmentsParameters
 */
export const createHtmlFragment = ({ id, html = '', styles, dataset }: CreateHtmlFragmentsParameters) => createIframeElement({
    id,
    srcdoc: addHtmlStructure(html),
    styles,
    dataset,
});
